module.exports = __webpack_public_path__ + "static/media/connect-github.53b0f114.svg";